import { FC, Fragment } from "preact/compat";
import type { ReceiptSheetProps } from "./interfaces";
import cn from "classnames";

const ReceiptSheet: FC<ReceiptSheetProps> = ({
    className,
    properties,
    height,
    heading,
    estimateText,
    estimateTextExtended,
    children,
}) => (
    <div
        style={{
            height,
        }}
        className={cn(
            "aspect-[1/1.414] min-w-[560px] bg-white border border-gray-200 shadow-lg",
            className
        )}
    >
        <div className="w-full h-full px-8 py-4">
            <div className="w-full h-[80px] border border-blue-300 bg-blue-100 flex items-center p-4 tracking-widest uppercase text-gray-400 select-none">
                Your logo
            </div>
            <div className="flex flex-col mt-8">
                <span className="text-xl">{heading || "Heading here..."}</span>
            </div>
            <div className="grid grid-cols-3 pb-4 mt-4 text-sm border-b border-gray-300">
                {properties?.map(([title, value], index) => (
                    <Fragment key={index}>
                        <span className="font-bold">{title}</span>
                        <span className="col-span-2">{value}</span>
                    </Fragment>
                ))}
            </div>
            <p className="pt-2">{estimateText ?? "Estimate text..."}</p>
            <div className="mt-4">
                {children || (
                    <div className="text-xl text-gray-500">Placeholder</div>
                )}
            </div>
            <div className="flex flex-col mt-4">
                <p className="mt-1">
                    {estimateTextExtended ?? "Estimate text extended..."}
                </p>
            </div>
        </div>
    </div>
);

export default ReceiptSheet;
